import React, { Suspense } from "react";
import FirstBlock from "./FirstBlock";
import BannerBlock from "./BannerBlock";
import HowItWorksBlocks from "./HowItWorksBlocks";
import ForthBlock from "./ForthBlock";
const IconsBlock = React.lazy(() => import("./IconsBlock"));

export const getBlock = (block, community) => {
  switch (block.type) {
    case "first":
      return <FirstBlock block={block} community={community} />;
    case "banner":
      return <BannerBlock block={block} community={community} />;
    case "icons":
      return (
        <Suspense fallback={<div />}>
          <IconsBlock block={block} community={community} />
        </Suspense>
      );
    case "how-it-works":
      return <HowItWorksBlocks block={block} community={community} />;
    case "forth":
      return <ForthBlock block={block} community={community} />;
    default:
      return null;
  }
};
